import React from 'react'

import Factory from '../Components/Component/Factory.jsx';
import Why from "../Components/Component/Why_Us.jsx";
import Scroll from "../Components/Component/Scroll.jsx";
import Hover from "../Components/Component/Hover.jsx";
import Choose from "../Components/Component/Choose.jsx";
import Footer from '../Components/Component/Footer.jsx';
import Static_Scroll from '../Components/Component/Static_Scroll.jsx';
import UshasVas from '../Components/Component/UshasVas.jsx';

const Home = () => {
  return (
    <div>


    <Factory />
    <Why />

    <Static_Scroll />
    <Hover />
    <UshasVas />
    <Scroll />
    <Choose />

    <Footer />

    </div>
  )
}

export default Home


